import * as io from "io-ts";
import createGlobalState from "../../lib/createGlobalState";
import { withFallback } from "io-ts-types";
import { parseAbsolute } from "@internationalized/date";

export const usePeriodState = createGlobalState({
  storage: "session",
  key: "period",
  type: withFallback(
    io.strict({
      from: io.number,
      to: io.number,
    }),
    {
      from: parseAbsolute(
        new Date().toISOString(),
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      )
        .add({ months: -3 })
        .set({ hour: 0, minute: 0, second: 0 })
        .toDate()
        .getTime(),
      to: new Date().getTime(),
    },
  ),
  scoped: true,
});

export interface Period {
  from: number;
  to: number;
}

export function isInPeriod(period: Period, date: number) {
  return period.from <= date && date <= period.to;
}

function usePeriod(
  scope: string,
  _extremes: Period,
  initialPeriod: () => { from: number; to: number },
) {
  return usePeriodState({
    scope,
    defaultValue: initialPeriod(),
  });
}

export default usePeriod;
